import { defineMessages } from 'react-intl-next';

export const avatarGroupMessages = defineMessages({
	editors: {
		id: 'fabric.editor.editors',
		defaultMessage: 'Editors',
		description: 'classifying the people that are currently editing the document',
	},
});
